import type {
  FontSystemIssue,
  LayoutMissingFontImportIssue,
  LayoutMissingFontTagIssue,
  MissingLayoutAstroIssue,
} from "./types"
import {
  LAYOUT_PATH,
  REQUIRED_BODY_CSS_VARIABLE,
  REQUIRED_HEADING_CSS_VARIABLE,
} from "./constants"

const missingLayoutAstro = (): MissingLayoutAstroIssue => ({
  _tag: "MissingLayoutAstro",
  path: LAYOUT_PATH,
})

const layoutMissingFontImport = (): LayoutMissingFontImportIssue => ({
  _tag: "LayoutMissingFontImport",
  path: LAYOUT_PATH,
})

const layoutMissingFontTag = (
  cssVariable: "--font-provider-body" | "--font-provider-heading",
): LayoutMissingFontTagIssue => ({
  _tag: "LayoutMissingFontTag",
  path: LAYOUT_PATH,
  cssVariable,
})

const hasRequiredFontTag = (
  input: string,
  cssVariable: "--font-provider-body" | "--font-provider-heading",
): boolean => {
  const tags = Array.from(input.matchAll(/<Font\b[^>]*>/g), (match) => match[0])
  return tags.some((tag) => tag.includes(`cssVariable="${cssVariable}"`) && /\bpreload\b/.test(tag))
    || tags.some((tag) => tag.includes(`cssVariable='${cssVariable}'`) && /\bpreload\b/.test(tag))
}

export const validateLayoutFontInjection = (
  input: string | null | undefined,
): readonly FontSystemIssue[] => {
  if (input == null) {
    return [missingLayoutAstro()]
  }

  const issues: FontSystemIssue[] = []

  if (!/import\s*\{\s*Font\s*\}\s*from\s*["']astro:assets["']/.test(input)) {
    issues.push(layoutMissingFontImport())
  }

  if (!hasRequiredFontTag(input, REQUIRED_BODY_CSS_VARIABLE)) {
    issues.push(layoutMissingFontTag(REQUIRED_BODY_CSS_VARIABLE))
  }

  if (!hasRequiredFontTag(input, REQUIRED_HEADING_CSS_VARIABLE)) {
    issues.push(layoutMissingFontTag(REQUIRED_HEADING_CSS_VARIABLE))
  }

  return issues
}
